<p-dialog [visible]="true" [closable]="false" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<fa-icon [icon]="['far', 'inbox-out']" class="me-4" size="lg"></fa-icon>
		<div class="h3">Marketing Blast</div>
	</ng-template>

	<div class="d-flex flex-wrap flex-fill mt-4">
		<div class="w-100 mt-4 mx-2 mb-2">
			<span class="p-float-label">
				<input #blastSubject pInputText type="text" name="name" [(ngModel)]="blast.subject" class="w-100" />
				<label for="blastSubject">Email Subject</label>
			</span>
		</div>

		<div class="w-100 mt-4 mx-2 mb-2">
			<span class="p-float-label">
				<p-multiSelect
					#groupListSelect
					[options]="groupList"
					optionLabel="name"
					optionValue="sk"
					name="groupListSelect"
					[(ngModel)]="blast.groupKeyList"
					styleClass="w-100"
					appendTo="body"
				></p-multiSelect>
				<label for="groupList">Select who you want to send to...</label>
			</span>
		</div>
		<div class="w-100 mt-4 mx-2 mb-2">
			<span class="p-float-label">
				<p-dropdown
					#templateListSelect
					[autoDisplayFirst]="false"
					[options]="templateList"
					optionLabel="name"
					optionValue="sk"
					name="templateListSelect"
					[(ngModel)]="blast.templateKey"
					styleClass="w-100"
					appendTo="body"
				>
				</p-dropdown>
				<label for="templateList">What do you want to send?</label>
			</span>
		</div>

		<div class="w-100 mt-4 mx-2 mb-2">
			<span class="p-float-label">
				<input #blastName pInputText type="text" name="name" [(ngModel)]="blast.name" class="w-100" />
				<label for="blastName">Blast Name</label>
			</span>
		</div>
		<div class="w-100 mt-4 mx-2 mb-2">
			<span class="p-float-label">
				<textarea #blastDescription pInputTextarea [(ngModel)]="blast.description" class="w-100"></textarea>
				<label for="blastDescription">Description</label>
			</span>
		</div>
		<div class="w-100 mt-4 mx-2 mb-2">
			<span class="p-float-label">
				<p-calendar
					#sendDate
					[minDate]="today"
					[showTime]="true"
					[(ngModel)]="blast.sendDateDateFormat"
					styleClass="w-100"
					appendTo="body"
				></p-calendar>
				<label for="sendDate">When do you want to send?</label>
			</span>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<div class="d-flex w-100 justify-content-end">
			<app-record-control-footer
				[hideCancel]=""
				[hideDelete]=""
				[hideSave]=""
				(onCancelChange)="blastChange.emit(undefined)"
				(onDeleteChange)="blastDelete(blast)"
				(onSaveChange)="saveWithoutScheduling()"
				[cancelDisabled]=""
				[deleteDisabled]="!blast.sk"
				[saveDisabled]=""
			></app-record-control-footer>
			<p-button pRipple styleClass="p-button-raised p-button-success m-2" (click)="saveAndSchedule()">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'calendar-check']" size="lg" class="ms-1"></fa-icon>
					Save & Schedule
				</ng-template>
			</p-button>
		</div>
	</ng-template>
</p-dialog>
